import { graphql } from "react-relay"

export const dePrescriptionFragment = graphql`
  fragment dePrescriptionFragment on de_Prescription {
    patientId
    progressNoteId
    createdAt
    createdBy
    updatedAt
    updatedBy
    signedAt
    signedBy
    concludedAt
    concludedBy
    sentAt
    sentBy
    medications {
      id
    }
    fileId
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
